import React, { FC } from 'react';
import styles from './entity_block_components.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';

export const EntityBlock: FC<{ id?: string }> = ({ children, id }) => (
  <div id={id} className={styles.block}>
    {children}
  </div>
);

export const EntityBlockTitle: FC<{
  htmlTagName?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
}> = ({ children, htmlTagName = 'h3' }) => {
  const Component = htmlTagName;
  return <Component className={styles.title}>{children}</Component>;
};

export const EntityBlockSubtitle: FC = ({ children }) => (
  <div className={styles.subtitle}>{children}</div>
);

export const EntityBlockSubtitleText: FC = ({ children }) => (
  <div className={styles.subtitleText}>{children}</div>
);

export const EntityBlockInfoIcon: FC = () => (
  <MaterialIcon name="info_outline" className={styles.icon} />
);
